import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiLock } from 'react-icons/fi';
import BrandLogo from './BrandLogo';
import { login } from '../lib/api';

const Login = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      await login(password);
      onLogin(true);
    } catch (err) {
      setError('Falsches Passwort. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#f0f7fb]">
      <header className="bg-white border-b border-gray-200 py-4 px-6 flex items-center justify-center shadow-sm">
        <BrandLogo />
      </header>

      <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full bg-white p-10 rounded-2xl shadow-xl border border-gray-100">
          <div className="text-center">
            <div className="mx-auto h-16 w-16 bg-[#f0f7fb] rounded-full flex items-center justify-center mb-6">
              <SafeIcon icon={FiLock} className="h-8 w-8 text-[#005b9f]" />
            </div>
            <h2 className="text-3xl font-extrabold text-gray-900 mb-2">Admin Login</h2>
            <p className="text-sm text-gray-500 mb-8">Geschützter Bereich für den Datei-Upload</p>
          </div>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Passwort</label>
              <input 
                type="password" 
                required 
                className="appearance-none rounded-lg block w-full px-4 py-3 border border-gray-300 placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#005b9f] sm:text-sm"
                placeholder="Bitte Passwort eingeben"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {error && (
              <div className="text-red-600 text-sm font-medium bg-red-50 p-3 rounded-lg border border-red-100 flex items-center">
                <SafeIcon icon={FiLock} className="mr-2" />
                {error}
              </div>
            )}

            <button 
              type="submit" 
              disabled={loading}
              className="w-full flex justify-center py-3 px-4 border border-transparent text-sm font-bold rounded-full text-white bg-[#005b9f] hover:bg-[#004a82] focus:outline-none transition-colors shadow-md disabled:opacity-50"
            >
              {loading ? 'Prüfe...' : 'Anmelden'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;